<template>
	<div>
		<v-row v-if="error_msg.length !== 0" class="ma-0">
			<v-col cols="12">
				<v-alert type="error" class="mb-0">
					{{ error_msg }}
				</v-alert>
			</v-col>
		</v-row>
		<ProgressLinear v-if="loading"/>
		<v-row v-if="!loading" class="ma-0">		
			<v-col v-if="$vuetify.breakpoint.smAndDown ? !is_create && job_status_id === 0 : true" :cols="$vuetify.breakpoint.smAndDown? 12:3">
				<v-row class="ma-0" justify="space-between">
					<v-btn class="text-capitalize white--text" :color="color" @click="is_create = true; hex = {r: 0, g: 0, b: 0}; job_status_id = 0">
						<v-icon>mdi-plus</v-icon>
						New Job Status
					</v-btn>
					<v-btn v-if="$vuetify.breakpoint.smAndDown" icon @click="$emit('close');">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-row>
				<div class="list-wrap" :style="`height: ${$vuetify.breakpoint.height - 260}px`">
					<div class="list-wrap-container">
						<v-expansion-panels
							v-model="panel"
							multiple
							accordion
							flat
						>
							<v-expansion-panel
								v-for="item in panel_items"
								:key="item.value"
							>
								<v-expansion-panel-header class="py-2 px-3" style="min-height: 48px;">
									<template v-slot:default="{ open }" >
										<div>
											<v-icon class="icon mr-2">{{ open ? 'mdi-folder-open-outline' : 'mdi-folder' }}</v-icon>
											<span class="header">{{ item.title }}</span>
										</div>
									</template>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-draggable
										:list="status_group[`${item.value}`]"
										@update="onDrag($event, item.value)"
									>
										<v-list-item-title v-for="status in status_group[`${item.value}`]" :key="status.id" class="task-status-hover rounded" @click="getJobStatus(status.id)">
											<v-row class="mx-0 my-2" :align="`center`">
												<DragIcon style="width: 20px; height: 20px;" :color="status.rgba" />
												<div>
													<span class="ml-2" :style="!status.is_active ? 'text-decoration-line: line-through; opacity: 0.5':''">{{status.description }}</span>
													<span class="ml-2 rounded-pill inactive-text px-2" v-if="!status.is_active">Inactive</span>
													<span class="ml-2 rounded-pill default-text px-2" v-if="status.is_default">Default</span>
												</div>
											</v-row>
										</v-list-item-title>
									</v-draggable>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</div>
				</div>
			</v-col>
			<v-col v-if="$vuetify.breakpoint.smAndDown ? !is_create && job_status_id !== 0 : !is_create" :cols="$vuetify.breakpoint.smAndDown? 12:9">
				<div class="list-wrap" :style="`height: ${$vuetify.breakpoint.height - 224}px`">
					<div class="list-wrap-container">
						<v-row :class="$vuetify.breakpoint.smAndDown ? 'mt-0 mx-0 mb-3':'ma-0'" justify="space-between">
							<v-row class="ma-0">
								<v-btn outlined class="text-capitalize" :color="color" @click="onDuplicate()">
									<v-icon small class="mr-1">mdi-content-copy</v-icon>
									Duplicate
								</v-btn>
								<v-btn outlined class="text-capitalize mx-3" :color="`#F45252`" @click="onDelete()">
									<v-icon size="20" class="mr-1">mdi-delete-outline</v-icon>
									Delete
								</v-btn>
								<v-btn v-if="isDetailChange && !$vuetify.breakpoint.smAndDown" class="text-capitalize white--text" :color="color" elevation="0" @click="onSaveChange()">
									<SaveIcon class="mr-1" :color="'white'" width="20" height="20"/>
									Save changes
								</v-btn>
							</v-row>
							<v-btn icon @click="onClose()">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-row>
						<v-row class="mt-3 mx-0 mb-2" v-if="isDetailChange && $vuetify.breakpoint.smAndDown">
							<v-btn block class="text-capitalize white--text" :color="color" elevation="0" @click="onSaveChange()">
								<SaveIcon class="mr-1" :color="'white'" width="20" height="20"/>
								Save changes
							</v-btn>
						</v-row>
						<ProgressLinear v-if="loading_status"/>
						<template v-if="!loading_status">
							<v-row class="ma-0" :align="`center`">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4" class="pl-0">
									<v-row class="ma-0">
										<div class="title-text title-text-color mr-2">
											Job status group
										</div>
									</v-row>
									<v-select
										v-model="select_status_group"
										:items="panel_items"
										:menu-props="{ bottom: true, offsetY: true}"
										:color="color"
										background-color="#FAFAFA"
										:item-color="color"
										item-text="title"
										outlined
										dense
										hide-details
									>
									</v-select>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4" :class="$vuetify.breakpoint.smAndDown ? 'pl-0':''">
									<v-row class="ma-0">
										<div class="title-text mr-2" :class="!job_name || (job_name && job_name.length === 0) ? 'title-text-color-red' : 'title-text-color'">
											Job status name 
										</div>
									</v-row>
									<v-text-field
										v-model="job_name"
										:color="color"
										:error="!job_name || (job_name && job_name.length === 0)"
										background-color="#FAFAFA"
										outlined
										hide-details
										clearable
										dense
									></v-text-field>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4" :class="$vuetify.breakpoint.smAndDown ? 'pl-0 py-0':''">
									<v-checkbox
										v-model="status_inactive"
										:color="color"
										hide-details
										dense
									>
										<template v-slot:label>
											<span class="mr-2 checkbox-text">Mark as inactive</span>
											<v-tooltip attach right max-width="calc(55%)" z-index="11">
												<template v-slot:activator="{ on, attrs }">
													<div v-bind="attrs" v-on="on">
														<InfoOutline class="mt-1" width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
													</div>
												</template>
												<span>Disables this Job status for new jobs and new jobs created. Also disables changing old jobs back to this status</span>
											</v-tooltip>
										</template>
									</v-checkbox>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col cols="12" class="pl-0">
									<div class="title-text title-text-color mr-2">
										Job status description
									</div>
									<v-textarea
										v-model="job_desc"
										:color="color"
										background-color="#FAFAFA"
										outlined
										hide-details
										clearable
										dense
										auto-grow
										rows="1"
									></v-textarea>
									<div style="text-align: right" class="optional-text">optional</div>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col cols="12" class="pl-0">
									<div class="title-text title-text-color mr-2">
										Apply to the following Job Types:
									</div>
									<v-autocomplete
										v-model="job_types"
										:items="type_items"
										:color="color"
										:item-color="color"
										item-text="desc"
										item-value="id"
										background-color="#FAFAFA"
										prepend-inner-icon="search"
										append-icon=""
										outlined
										dense
										hide-no-data
										hide-details
										multiple
										return-object
										clearable
									>
									</v-autocomplete>
								</v-col>
							</v-row>
							<div class="title-text title-text-color">Set job status colour</div>
							<v-color-picker
								v-model="taskColor"
								class="mt-1"
								canvas-height="120"
								hide-mode-switch
							></v-color-picker>
						</template>
					</div>
				</div>
			</v-col>
			<v-col v-if="is_create" :cols="$vuetify.breakpoint.smAndDown? 12:9">
				<div class="list-wrap" :style="`height: ${$vuetify.breakpoint.smAndDown ? $vuetify.breakpoint.height - 260 :$vuetify.breakpoint.height - 224}px`">
					<div class="list-wrap-container">
						<v-row class="ma-0" justify="space-between">
							<v-row class="ma-0">
								<v-btn class="text-capitalize white--text" :color="color" elevation="0" :disabled="!isCreateAvailable" @click="onCreate()">
									Create Status 
								</v-btn>
							</v-row>
							<v-btn icon @click="onClose()">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-row>
						<v-row class="ma-0" :align="`center`">
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4" class="pl-0">
								<v-row class="ma-0">
									<div class="title-text title-text-color mr-2">
										Job status group
									</div>
									<v-tooltip attach right max-width="calc(55%)" z-index="11">
										<template v-slot:activator="{ on, attrs }">
											<div v-bind="attrs" v-on="on">
												<InfoOutline width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
											</div>
										</template>
										<span>JobBag has 4 default task status types.</span>
									</v-tooltip>
								</v-row>
								<v-select
									v-model="create_status_group"
									:items="panel_items"
									:menu-props="{ bottom: true, offsetY: true}"
									color="rgba(25, 42, 62, 0.7)"
									background-color="#FAFAFA"
									:item-color="color"
									item-text="title"
									outlined
									dense
									hide-details
								>
								</v-select>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4" :class="$vuetify.breakpoint.smAndDown ? 'pl-0':''">
								<v-row class="ma-0">
									<div class="title-text mr-2" :class="!create_name || (create_name && create_name.length === 0) ? 'title-text-color-red' : 'title-text-color'">
										Job status name
									</div>
									<v-tooltip attach right max-width="calc(55%)" z-index="11">
										<template v-slot:activator="{ on, attrs }">
											<div v-bind="attrs" v-on="on">
												<InfoOutline width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
											</div>
										</template>
										<span>Use this field to write a description of what this task status means. Users in your organisation will see this when they click on the information icon.</span>
									</v-tooltip>
								</v-row>
								<v-text-field
									v-model="create_name"
									:color="color"
									:error="!create_name || (create_name && create_name.length === 0)"
									background-color="#FAFAFA"
									outlined
									hide-details
									clearable
									dense
								></v-text-field>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4" :class="$vuetify.breakpoint.smAndDown ? 'pl-0 py-0':''">
								<v-checkbox
									v-model="create_inactive"
									:color="color"
									hide-details
									dense
								>
									<template v-slot:label>
										<span class="mr-2 checkbox-text">Mark as inactive</span>
										<v-tooltip attach right max-width="calc(55%)" z-index="11">
											<template v-slot:activator="{ on, attrs }">
												<div v-bind="attrs" v-on="on">
													<InfoOutline class="mt-1" width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
												</div>
											</template>
											<span>Disables this Job status for new jobs and new jobs created. Also disables changing old jobs back to this status</span>
										</v-tooltip>
									</template>
								</v-checkbox>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col cols="12" class="pl-0">
								<div class="title-text title-text-color mr-2">
									Job status description
								</div>
								<v-textarea
									v-model="create_desc"
									:color="color"
									background-color="#FAFAFA"
									outlined
									hide-details
									clearable
									dense
									auto-grow
									rows="1"
								></v-textarea>
								<div style="text-align: right" class="optional-text">optional</div>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col cols="12" class="pl-0">
								<div class="title-text title-text-color mr-2">
									Apply to the following Job Types:
								</div>
								<v-autocomplete
									v-model="create_types"
									:items="type_items"
									:color="color"
									:item-color="color"
									item-text="desc"
									item-value="id"
									background-color="#FAFAFA"
									prepend-inner-icon="search"
									append-icon=""
									outlined
									dense
									hide-no-data
									hide-details
									multiple
									return-object
									clearable
								>
								</v-autocomplete>
							</v-col>
						</v-row>
						<div class="title-text title-text-color">Set job status colour</div>
						<v-color-picker
							v-model="createColor"
							class="mt-1"
							canvas-height="120"
							hide-mode-switch
						></v-color-picker>
					</div>
				</div>
			</v-col>
		</v-row>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
		/>
		<DeleteConfirmDialog 
			v-if="unsaved_visible"
			:visible="unsaved_visible" 
			:color="'error'"
			:title="`Your changes have not been saved`" 
			:content="'Are you sure you want to leave this page without saving changes?'"
			:cancel="'Go back'"
			:ok="'Yes, leave'"
			:icon_name_title="'mdi-alert-circle'"
			:maxWidth="500"
			@cancel="unsaved_visible = false"
			@ok="onLeave()"
		/>
		<DeleteConfirmDialog 
			v-if="delete_visible"
			:visible="delete_visible" 
			:color="'error'"
			:title="del_title" 
			:content="del_content"
			:cancel="'Go back'"
			:ok="del_ok"
			:icon_name_title="'mdi-alert-circle'"
			:maxWidth="500"
			@cancel="delete_visible = false"
			@ok="onDeleteStatus()"
		/>
	</div>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import DragIcon from "@/components/icons/drag.vue";

import SaveIcon from "@/components/icons/save.vue";
import InfoOutline from "@/components/icons/info_outline";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";

/** from src/db/models/job.rs */
const Panel_Items = [
	{
		title: 'Proposed',
		value: 0
	},
	{
		title: 'Live',
		value: 1
	},
	{
		title: 'On Hold',
		value: 2
	},
	{
		title: 'Cancelled',
		value: 3
	},
	{
		title: 'Complete',
		value: 4
	},
	{
		title: 'Dead',
		value: 5
	}
];

export default {
	name: 'JobStatus',
	components: {
		ProgressLinear,
		DragIcon,
		SaveIcon,
		InfoOutline,
		DialogNotice,
		DeleteConfirmDialog
	},
	props: {
		color: {
			type: String,
			default: ''
		}
	},
	data() {
		this.panel_items = Panel_Items;

		return {
			error_msg: '',
			loading: false,
			loading_status: false,

			panel: this.id === 0 ? [0] : Panel_Items.map((k, i) => { return i}),
			status_group: null,
			job_statuses: [],
			type_items: [],

			select_status_group: 0,
			job_status_id: 0,
			job_name: '',
			job_desc: '',
			hex: { r: 0, g: 0, b: 0 },
			status_inactive: false,
			origin_job_types: [],
			job_types: [],

			is_create: false,
			create_status_group: 1,
			create_name: '',
			create_desc: '',
			create_inactive: false,
			create_types: [],

			del_title: '',
			del_content: '',
			del_ok: '',

			visible_notice: false,
			notice_text: [],
			tid: null,

			unsaved_visible: false,
			delete_visible: false,
		}
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	async created() {
		await this.getJobStatusList();
		await this.getJobTypeList();

		const first_key = (Object.keys(this.status_group))[0];
		const first_status_arr = this.status_group[`${first_key}`];
		const first_open_status = first_status_arr[0];

		if (!this.$vuetify.breakpoint.smAndDown) {
			this.getJobStatus(first_open_status.id)
		}
	},
	computed: {
		isDetailChange() {
			let is_change = false;

			if (this.job_status_id !== 0) {
				const is_need_types =  this.status_inactive ? true : this.job_types.length !== 0;
				if (is_need_types) {
					const origin_job = this.job_statuses.filter(t => { return t.id === this.job_status_id });
					if (origin_job.length !== 0) {
						const color_rgb = `rgb(${this.taskColor.r},${this.taskColor.g},${this.taskColor.b})`;

						const origin_job_type_id_arr = this.origin_job_types.map(t => { return t.id });
						origin_job_type_id_arr.sort((a,b) => { return a-b });

						const job_type_id_arr = this.job_types.map(t => { return t.id });
						job_type_id_arr.sort((a,b) => { return a-b });

						if (origin_job[0].status_group !== this.select_status_group
							|| (origin_job[0].description !== this.job_name)
							|| (origin_job[0].comment !== this.job_desc)
							|| origin_job[0].is_active === this.status_inactive
							|| origin_job[0].color_rgb !== color_rgb
							|| origin_job_type_id_arr.join() !== job_type_id_arr.join()
						) {
							is_change = true;
						}
					}
				}				
			}

			return is_change;
		},
		isCreateAvailable() {
			let is_available = false;
			if (this.is_create) {
				const is_need_types = this.create_inactive ? true : this.create_types.length !== 0;
				if (this.create_name && this.create_name.length !== 0 && is_need_types) {
					is_available = true;
				}
			}
			return is_available;
		},
		taskColor: {
			get () {
				return this['hex']
			},
			set (v) {
				this['hex'] = v
			},
		},
		createColor: {
			get () {
				return this['hex']
			},
			set (v) {
				this['hex'] = v
			},
		}
	},
	watch: {
		isDetailChange() {
			this.$emit('change', this.isDetailChange);
		},
		is_create() {
			this.$emit('change', this.is_create);
		}
	},
	methods: {
		async getJobTypeList() {
			this.loading = true;

			const params = [];
			params.push("include_inactive=false");

			let url = "/api/config/jobs/jobtype";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status == "OK") {
						this.type_items = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async getJobStatusList(need_loading=true) {
			if (need_loading) {
				this.loading = true;
			}

			const url = '/api/config/jobs/jobstatus';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status == "OK") {
						this.job_statuses = data;

						const status_group_obj = {};

						this.panel_items.forEach(element => {
							status_group_obj[`${element.value}`] = [];
						});

						data.forEach(d => {
							d['rgba'] = d.color_rgb;

							(status_group_obj[`${d.status_group}`]).push(d);
						});

						this.status_group = status_group_obj;
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					if (need_loading) {
						this.loading = false;
					}
				});
		},
		getJobStatus(id) {
			this.loading_status = true;

			const url = `/api/config/jobs/jobstatus/${id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status == "OK") {
						this.origin_job_types = data.job_types;
						this.onShowStatus(data, data.status_group);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading_status = false;
				});
		},
		onShowStatus(status, group_value) {
			if (this.is_create) {
				this.is_create = false;
			};

			this.select_status_group = group_value;
			this.job_status_id = status.id;
			this.job_name = status.description;
			this.job_desc = status.comment;
			this.hex = this._getRgbaValue(status.color_rgb);
			this.status_inactive = !status.is_active;
			this.job_types = status.job_types;
		},
		onDrag({oldIndex, newIndex}, group_id) {
			const move_group = this.status_group[`${group_id}`];
			const move_obj = move_group.filter(group => { return group.status_order === oldIndex });

			if (move_obj.length !== 0) {
				const params = [];
				params.push(`new_order=${newIndex}`);

				let url = `/api/config/jobs/jobstatus/${move_obj[0].id}/change_order`;
				if (params.length > 0) {
					url+= "?" + params.join('&');
				}

				axios
					.post(url, {
						headers: {
							Authorization: 'Bearer ' + this.$store.state.token,
							Accept: 'application/json',
						},
					})
					.then((val) => {
						const {status, reason} = val.data;

						if (status == "OK") {
							this.getJobStatusList(false);

							const first_key = (Object.keys(this.status_group))[0];
							const first_status_arr = this.status_group[`${first_key}`];
							const first_open_status = first_status_arr[0];
							this.getJobStatus(first_open_status.id)
						} else {
							this.error_msg = reason;
						}
					})
					.catch((e) => {
						this.error_msg = e.message;
					});
			}
		},
		onDuplicate() {
			this.create_status_group = this.select_status_group;
			this.create_name = this.job_name;
			this.create_desc = this.job_desc;
			this.create_inactive = this.status_inactive;
			this.create_types = this.job_types;
			this.is_create = true;
		},
		onSaveChange() {
			const param_obj = {};
			param_obj['is_default'] = false;
			param_obj['is_active'] = !this.status_inactive;
			param_obj['code'] = this.job_name[0];
			param_obj['status_group'] = this.select_status_group;
			param_obj['description'] = this.job_name;
			param_obj['comment'] = this.job_desc;
			param_obj['color'] = this._rgbToDecimal(this.taskColor);

			const job_select = this.job_statuses.filter(j => { return j.id === this.job_status_id });
			param_obj['status_order'] = job_select[0].status_order;

			const job_types = this.job_types.map(t => { return { type_id: t.id }});
			param_obj['allowed_types'] = job_types;
						
			this._changeTaskStatus(param_obj);
		},
		onDelete() {
			const current_task_status = this.job_statuses.filter(status => { return status.id === this.job_status_id });
			const is_used = current_task_status[0].is_used;

			if (is_used) {
				this.del_title = 'Job Status in use';
				this.del_content = 'This Job status cannot be deleted as it is in use. It can be marked inactive, if you don’t want it to be used for future Jobs. ';
				this.del_ok = 'Mark inactive';
				this.delete_visible = true;

			} else {
				this.del_title = `You are about to delete Job Status ‘${current_task_status[0].description}’`;
				this.del_content = 'This action cannot be undone. Are you sure?';
				this.del_ok = 'Yes, delete';
				this.delete_visible = true;
			}
		},
		onDeleteStatus() {
			const current_task_status = this.job_statuses.filter(status => { return status.id === this.job_status_id });
			const is_used = current_task_status[0].is_used;

			if (is_used) {
				const param_obj = {};
				param_obj['is_active'] = false;
				param_obj['is_default'] = current_task_status[0].is_default;
				param_obj['code'] = current_task_status[0].code;
				param_obj['status_group'] = current_task_status[0].status_group;
				param_obj['description'] = current_task_status[0].description;
				param_obj['comment'] = current_task_status[0].comment;
				param_obj['color'] = current_task_status[0].color;
				param_obj['status_order'] = current_task_status[0].status_order;

				const job_types = this.job_types.map(t => { return { type_id: t.id }});
				param_obj['allowed_types'] = job_types;

				this._changeTaskStatus(param_obj);
			} else {
				this._deleteTaskStatus(current_task_status[0])
			}
		},
		onCreate() {
			const param_obj = {};
			param_obj['is_default'] = false;
			param_obj['is_active'] = !this.create_inactive;
			param_obj['code'] = this.create_name[0];
			param_obj['status_group'] = this.create_status_group;
			param_obj['description'] = this.create_name;
			param_obj['comment'] = this.create_desc;
			param_obj['status_order'] = (this.status_group[`${this.create_status_group}`]) .length + 1;
			param_obj['color'] = this._rgbToDecimal(this.createColor);
			const job_types = this.create_types.map(t => { return { type_id: t.id }});
			param_obj['allowed_types'] = job_types;

			const url = `/api/config/jobs/jobstatus/`;
			axios
				.post(url, param_obj, {
					headers: {
						Authorization: 'Bearer ' + this.$store.state.token,
						Accept: 'application/json',
					},
				})
				.then((val) => {
					const {status, reason} = val.data;

					if (status == "OK") {
						this._initCreateSettings();
						
						this.getJobStatusList();

						this.notice_text.push('Job Status has been created successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						if (this.$vuetify.breakpoint.smAndDown) {
							this._initEditSettings();
							this._initCreateSettings();
						} else {
							const first_key = (Object.keys(this.status_group))[0];
							const first_status_arr = this.status_group[`${first_key}`];
							const first_open_status = first_status_arr[0];

							this.getJobStatus(first_open_status.id)
						}

					} else {
						this.error_msg = reason;
					}
					
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		onClose() {
			if (this.isDetailChange || this.isCreateAvailable) {
				this.unsaved_visible = true;
			} else {
				if (this.$vuetify.breakpoint.smAndDown) {
					this._initEditSettings();
					this._initCreateSettings();						
				} else {
					this.$emit('close');
				}
			}
		},
		onLeave() {
			if (this.$vuetify.breakpoint.smAndDown) {
				this.unsaved_visible = false;
				this._initEditSettings();
				this._initCreateSettings();
			} else {
				this.$emit('close');
			}
		},
		async _changeTaskStatus(param_obj) {
			const url = `/api/config/jobs/jobstatus/${this.job_status_id}`;
			axios
				.put(url, param_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason} = val.data;
					if (status == "OK") {
						this.getJobStatusList();

						this.notice_text.push('Job Status has been updated successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);	

						if (this.delete_visible) {
							this.delete_visible = false;

							if (this.$vuetify.breakpoint.smAndDown) {
								this.unsaved_visible = false;
								this._initEditSettings();
							} else {
								const first_key = (Object.keys(this.status_group))[0];
								const first_status_arr = this.status_group[`${first_key}`];
								const first_open_status = first_status_arr[0];

								this.getJobStatus(first_open_status.id)
							}
							
						} else {
							if (this.$vuetify.breakpoint.smAndDown) {
								this.unsaved_visible = false;
								this._initEditSettings();
							} else {
								data['rgba'] = data.color_rgb;
								this.getJobStatus(data.id)
							}
							
						}
										
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
		},
		async _deleteTaskStatus(status) {
			const url = `/api/config/jobs/jobstatus/${status.id}`;

			axios
				.delete(url, {
				}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, reason} = val.data;

					if (status == "OK") {
						this.delete_visible = false;

						this.getJobStatusList();

						this.notice_text.push('Task Status has been deleted successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
						
						if (this.$vuetify.breakpoint.smAndDown) {
							this.unsaved_visible = false;
							this._initEditSettings();
							
						} else {
							const first_key = (Object.keys(this.status_group))[0];
							const first_status_arr = this.status_group[`${first_key}`];
							const first_open_status = first_status_arr[0];

							this.getJobStatus(first_open_status.id)
						}						

					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
		},
		_getRGBFromDecimal(number) {
			const b = Math.floor(number / (256*256));
			const g = Math.floor(number / 256) % 256;
			const r = number % 256;
			
			return `rgba(${r},${g},${b})`;
		},
		_getRgbaValue(rgba_str) {
			const value_str = rgba_str.substring(rgba_str.indexOf('(') + 1, rgba_str.lastIndexOf(')'));
			const color_value = value_str.split(',');
			const value = { r: color_value[0], g: color_value[1], b: color_value[2] };

			return value;
		},
		_rgbToDecimal(rgba_obj) {
			const r = rgba_obj.r & 0xFF;
			const g = rgba_obj.g & 0xFF;
			const b = rgba_obj.b & 0xFF;

			const rgb = (b << 16) + (g << 8) + (r);
			return rgb;
		},
		_initEditSettings() {
			this.job_status_id = 0;
			this.select_status_group = 0;
			this.job_desc = '';
			this.job_name = '';
			this.hex = { r: 0, g: 0, b: 0 };
			this.status_inactive = false;
			this.job_types = [];
		},
		_initCreateSettings() {
			this.is_create = false;
			this.create_status_group = 1;
			this.create_desc = '';
			this.create_name = '';
			this.hex = { r: 0, g: 0, b: 0 };
			this.create_inactive = false;
			this.create_types = [];
		}
	}
}
</script>

<style lang="scss" scoped>
	.list-wrap {
		overflow: auto;
	}
	.list-wrap-container {
		height: 99%;
	}
	.title-text {
		font-family: Roboto;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.25px;
	}
	.title-text-color {
		color: rgba(55, 73, 95, 1);
	}
	.title-text-color-red {
		color: rgba(244, 82, 82, 1);
	}
	.inactive-text {
		background-color: rgba(232, 234, 236, 1);
		font-family: Roboto;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
		color: rgba(25, 42, 62, 0.7);
	}
	.default-text {
		background-color: rgba(220, 220, 220, 1);
		font-family: Roboto;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
		color: rgba(25, 42, 62, 1);
	}
	.checkbox-text {
		font-family: Roboto;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.25px;
		color: rgba(25, 42, 62, 0.5);
	}
	.task-status-hover {
		&:hover {
			background-color: #FAFAFA;
			cursor: pointer;
		}
	}
	.icon {
	  order: 0;
	}

	.header {
	  order: 1;
	}

	.optional-text {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 20px;

		text-align: right;
		letter-spacing: 0.4px;
		color: #37495F;
	}

	::v-deep  {
		.v-color-picker__input input {
			background-color: rgba(25, 42, 62, 0.15);
		}
	}	
</style>